<template>
    <div>
        <div class="profile-style">
            <h5 class="mb-4">Person in Event</h5>
            <div class="tabel-action tb-al mb-4 position-relative">
                <div v-if="detail_event.type === 'STANDARD'" class="disabled-feature bdr-15" @click.prevent="$emit('alertPackage')">
                    <i class="uil uil-lock-alt"></i>
                </div>
                <button type="button" v-b-modal.modal-CatPerson class="btn bg-white bdr-15 btn-block btn-lg"><i class="uil uil-plus mr-2"></i>Add Category Person</button>
            </div>

            <draggable
            v-bind="CatpersondragOptions" 
            v-model="CatpersonsGroup" 
            handle=".handle"
            @start="drag = true"
            @end="drag = false"
            >

            <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                <div v-for="(data,index_catperson) in CatpersonsGroup" @click="openPerson(data.id)" :class="[{ 'active' : active_person === data.id}]" class="mb-3 drag-gallery" :key="data.id" >
                    <div class="link" :class="[{ 'active' : active_person === data.id}]">
                        <div v-on:click.stop="" class="link-drag handle align-items-center d-flex">
                            <i class="uil uil-draggabledots"></i>
                        </div>
                        <div class="link-body cp">
                            <div class="link-content">
                                <div class="link-item pr-5">
                                    <div><strong>{{data.name}}</strong></div>
                                </div>
                                <div class="link-switch d-flex" v-on:click.stop="">
                                    <a href="#" v-b-modal.modal-CatPerson v-on:click.prevent="ASSIGN_FORM_CATPERSON(data)" class="act mb-0">
                                        <i class="uil uil-pen"></i>
                                    </a>
                                    <a href="#" v-on:click.prevent="alertDeleteCatPerson(data.id,index_catperson)" class="act mb-0">
                                        <i class="uil uil-trash-alt"></i>
                                    </a>
                                    <a href="#" v-on:click.prevent="openPerson(data.id)" class="act mb-0">
                                        <i :class="[active_person === data.id ? 'uil uil-angle-up' : 'uil uil-angle-down']"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                
                    </div>

                    <div class="gallery-wrapper" v-on:click.stop="">
                        <span class="gal-action position-relative">
                            <div v-if="detail_event.type === 'STANDARD' && data.person.length >= 2" class="btn-d disabled-feature bdr-15" @click.prevent="$emit('alertPackage')">
                                <i class="uil uil-lock-alt"></i>
                            </div>
                            <button type="button" v-b-modal.modal-Persons @click="formperson.id_category = data.id" class="btn btn-new-2 mb-3">
                                Add Person
                            </button>
                        </span>

                        <draggable
                            v-bind="personDragOptions" 
                            v-model="data.person" 
                            handle=".handle-p"
                            @change="updatePositionPerson(data.person)"
                            @start="drag_person = true"
                            @end="drag_person = false"
                            >

                            <transition-group type="transition" :name="!drag_person ? 'flip-list' : null">
                                <div v-for="(data,index_person) in data.person" :key="data.id" class="link child mb-3">
                                    <div class="link-drag handle-p align-items-center d-flex">
                                        <i class="uil uil-draggabledots"></i>
                                    </div>
                                    <div class="link-body">
                                        <div class="link-content">
                                            <div class="link-icon">
                                                <div class="no-img" v-if="!data.photo"><span class="w-100">NO IMAGE</span></div>
                                                <img v-if="data.photo" class="cn" :src="data.photo">
                                            </div>
                                            <div class="link-item pr-5">
                                                <div><strong>{{data.name}}</strong></div>
                                                <table>
                                                    <tr v-if="data.father">
                                                        <td>Father Name</td>
                                                        <td class="pl-2 pr-2">:</td>
                                                        <td>{{data.father}}</td>
                                                    </tr>
                                                    <tr v-if="data.mother">
                                                        <td>Mother Name</td>
                                                        <td class="pl-2 pr-2">:</td>
                                                        <td>{{data.mother}}</td>
                                                    </tr>
                                                    <tr v-if="data.type">
                                                        <td>Status</td>
                                                        <td class="pl-2 pr-2">:</td>
                                                        <td>{{data.type}}</td>
                                                    </tr>
                                                    <tr v-if="data.address">
                                                        <td>Address</td>
                                                        <td class="pl-2 pr-2">:</td>
                                                        <td>{{data.address}}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div class="link-switch">
                                                <a href="#" v-b-modal.modal-Persons v-on:click.prevent="ASSIGN_FORM_PERSON(data)" class="act">
                                                    <i class="uil uil-pen"></i>
                                                    <span class="link-tx"> Edit</span>
                                                </a>
                                                <a href="#" v-on:click.prevent="alertDelete(index_catperson,index_person,data.id)" class="act">
                                                    <i class="uil uil-trash-alt"></i>
                                                    <span class="link-tx"> Delete</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </transition-group>

                        </draggable>
                        
                    </div>
                    
                </div>
            </transition-group>

        </draggable>
            
        </div>

        
        <b-modal id="modal-CatPerson" centered hide-footer :title="modal_title_catperson" @hidden="CLEAR_FORM_CATPERSON">

            <ValidationObserver ref="formcatperson">
                <validation-provider rules="required" v-slot="{ errors }">
                    <div class="form-group">
                        <label>Person Category Name</label>
                        <input v-model="formcatperson.name" type="text" class="form-control" name="categories">
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>

                <div class="text-right">
                    <button v-on:click="validationFormCatPerson(formcatperson.id)" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                        Save Person Category
                    </button>
                </div>

            </ValidationObserver>

        </b-modal>
        
        <b-modal id="modal-Persons" size="lg" centered hide-footer :title="modal_title" @hidden="CLEAR_FORM_PERSON">

            <ValidationObserver ref="form">
                <b-row class="rw-people">
                    <b-col md="12">
                        <validation-provider v-if="!formperson.photo" rules="mimes:image/jpeg,image/png,image/jpg" v-slot="{ errors, validate }">
                            <div class="form-group">
                                <div class="mb-1">
                                    <label>Person Photo</label>
                                </div>
                                <div class="btn-up d-flex align-items-center" v-on:click.prevent="$refs.inputImage.click()">
                                    <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                                </div>
                                <input ref="inputImage" 
                                        type="file"
                                        class="custom-file-input d-none"
                                        id="Thumbnail"
                                        v-on:change="onImageUpload"
                                        accept="image/jpeg,image/png,image/jpg,image/webp" 
                                        @input="validate" >
            
                                <div class="invalid-input mt-3">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                        
                        <div class="form-group" v-if="formperson.photo">   
                            <div class="mb-1">
                                <label>Person Photo</label>
                            </div> 
                            <button v-on:click.prevent="removeImageUpload()" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button> 
                            <div class="input-group img-sh">
                                <img :src="formperson.photo" class="img-responsive img-prf">
                            </div>
                        </div>
                    </b-col>
                    <b-col md="12">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Person Name</label>
                                <input v-model="formperson.name" type="text" class="form-control" name="categories">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </b-col>
                    <b-col md="6">
                        <div class="form-group">
                            <label>Father Name</label>
                            <input v-model="formperson.father" type="text" class="form-control" name="categories">
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="form-group">
                            <label>Mother Name</label>
                            <input v-model="formperson.mother" type="text" class="form-control" name="categories">
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="form-group">
                            <label>Address</label>
                            <input v-model="formperson.address" type="text" class="form-control" name="categories">
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="form-group">
                            <label>Status</label>
                            <input v-model="formperson.type" type="text" class="form-control" name="categories">
                            <small>Ex : Anak Kedua, Putri Ketiga</small>
                        </div>
                    </b-col>
                    <b-col md="12">
                        <validation-provider rules="multi_url" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Social Media</label>
                                <textarea v-model="formperson.sosmed"
                                    @keydown.space.prevent
                                    placeholder="https://www.instagram.com/uinvited_official/, https://www.youtube.com/channel/UCs0aNfxB2GleV330Oj1kprw" class="form-control">
                                </textarea>
                                <div class="invalid-input">{{ errors[0] }}</div>
                                <small>Separate social media urls with commas(,) if you want to load more than one social media link</small>
                            </div>
                        </validation-provider>
                    </b-col>
                </b-row>
                
                <div class="text-right">
                    <button v-on:click="validationForm(formperson.id)" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                        Save Person
                    </button>
                </div>

            </ValidationObserver>

        </b-modal>


    </div>
</template>

<script>

    import { mapState, mapActions, mapMutations } from 'vuex'
    import {ValidationProvider, ValidationObserver } from "vee-validate";
    import draggable from 'vuedraggable'

    export default{
        data(){
            return{
                drag: false,
                drag_person:false,
                loading:false,
                loading_person:false,
                active_person:'',
                modal_title_catperson:'Add Category Person',
                modal_title : 'Add Person',
                photo_file:''
            }
        },
        watch:{
            'formperson':function(val){
                if(val.id){
                    this.modal_title = 'Edit Person'
                }else if(!val.id){
                    this.modal_title = "Add Person"
                }
            },
            'formcatperson':function(val){
                if(val.id){
                    this.modal_title_catperson = 'Edit Category Person'
                }else if(!val.id){
                    this.modal_title_catperson = "Add Category Person"
                }
            },
        },
        components: {
            ValidationProvider,
            ValidationObserver,
            draggable,
        },
        computed:{
            ...mapState('EventsControl', {
                detail_event: state => state.detail_event,
                formperson: state => state.formperson,
                formcatperson: state => state.formcatperson,
            }),

            CatpersondragOptions() {
                return {
                    animation: 200,
                    group: "catperson",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            personDragOptions() {
                return {
                    animation: 200,
                    group: "person",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            CatpersonsGroup: {
                get() {
                    return this.detail_event.catperson
                },
                set(value) {
                    this.SET_POSITION_CATPERSON(value)
                    this.updatePositionCatPerson(value)
                }
            },
        },
        methods:{
            ...mapMutations('EventsControl', ['SET_POSITION_PERSONS','CLEAR_FORM_PERSON','ASSIGN_FORM_PERSON','SET_POSITION_CATPERSON','CLEAR_FORM_CATPERSON','ASSIGN_FORM_CATPERSON']),
            ...mapActions('EventsControl', ['detailEvents','createPersons','updatePersons','deletePerson','updatePositionPerson',
                'createCatPerson','updateCatPerson','deleteCatPerson','updatePositionCatPerson'
            ]),
            
            // CAT PERSON
            openPerson: function(id){
                if(id == this.active_person){
                    this.active_person = ''
                }else{
                    this.active_person = id
                }
            },
            validationFormCatPerson: function(id) {
                this.$refs.formcatperson.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.formcatperson.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.formcatperson.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true
                        
                        if(id){

                            this.updateCatPerson(this.formcatperson).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-CatPerson')
                                this.detailEvents(this.$route.params.id)
                                this.CLEAR_FORM_CATPERSON()
                                this.$toast.success('Successfully Update Person Category')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            }) 

                        }else{

                            this.createCatPerson(this.formcatperson).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-CatPerson')
                                this.detailEvents(this.$route.params.id)
                                this.CLEAR_FORM_CATPERSON()
                                this.$toast.success('Successfully Added Person Category')
                            }).catch((error) => {
                                this.loading = false
                                if(error.response.data.errors == 'package'){
                                    this.$toast.warning('Sorry, Upgrade your package to use this feature')
                                }else{
                                    this.$toast.warning('Sorry, Something Error')
                                }
                            })
                        }
                    }
                });
            },
            alertDeleteCatPerson:function(id,index_catperson){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this person category data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deleteCatPerson(id).then(
                            this.$toast.success('Successfully Deleting Person Category'),
                            this.detail_event.catperson.splice(index_catperson, 1)
                        ).catch((error) => {
                            console.log(error)
                            this.$toast.warning('Sorry, Something Error')
                        })
                    }
                })
            },
            
            // PERSON
            onImageUpload: function(event) {
                var input = event.target;

                if (input.files && input.files[0]) {

                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = function(e) {
                        vm.formperson.photo = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                }
                this.photo_file = input.files[0]
            },
            removeImageUpload:function(){
                this.photo_file = ''
                this.formperson.photo = ''
            },
            validationForm: function(id) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        var formData = new FormData();
                        formData.append('id_category', this.formperson.id_category);
                        formData.append('name', this.formperson.name);
                        formData.append('mother', this.formperson.mother ? this.formperson.mother : '');
                        formData.append('father', this.formperson.father ? this.formperson.father : '');
                        formData.append('address', this.formperson.address ? this.formperson.address : '');
                        formData.append('type', this.formperson.type ? this.formperson.type : '');
                        formData.append('sosmed', this.formperson.sosmed ? this.formperson.sosmed : '');
                        formData.append('photo_file', this.photo_file);
                        formData.append('photo', this.formperson.photo ? this.formperson.photo : '');
                        
                        if(id){
                            formData.append("_method", "put");

                            this.updatePersons(formData).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Persons')
                                this.detailEvents(this.$route.params.id)
                                this.CLEAR_FORM_PERSON()
                                this.photo_file = ''
                                this.$toast.success('Successfully Update Person')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            })

                        }else{

                            this.createPersons(formData).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Persons')
                                this.detailEvents(this.$route.params.id)
                                this.photo_file = ''
                                this.CLEAR_FORM_PERSON()
                                this.$toast.success('Successfully Added Person')
                            }).catch((error) => {
                                this.loading = false
                                if(error.response.data.errors == 'package'){
                                    this.$toast.warning('Sorry, Upgrade your package to use this feature')
                                }else{
                                    this.$toast.warning('Sorry, Something Error')
                                }
                            }) 
                        }
                    }
                });
            },
            alertDelete:function(index_catperson,index_person,id){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this person data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deletePerson(id).then(
                            this.$toast.success('Successfully Deleting Person'),
                            this.detail_event.catperson[index_catperson].person.splice(index_person, 1)
                        ).catch((error) => {
                            console.log(error)
                            this.$toast.warning('Sorry, Something Error')
                        })
                    }
                })
            },
        }
    }

</script>
